import { promotionTypesSlice } from "./promotionTypesSlice";
import * as actions from "./promotionTypesActions";
import * as selectors from "./promotionTypesSelectors";

export { actions };
export { selectors };
export default promotionTypesSlice.reducer;
